<div class="task-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12 mb-4">
      <h3 class="text-lavuro m-0">
        <span class="pull-right">
          <button type="button" mat-icon-button (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>

        <span class="pull-left text-capitalize mr-4">
          Seleccionar Trabajo del Cliente
        </span>
        <span class="pull-left d-none d-lg-inline" style="width: 180px;">
          &nbsp;
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <!-- body content -->
  <div class="row" *ngIf="!loading">
    <div class="col-md-12">

      <div class="table-responsive">
        <table class="table table-responsive align-top">

          <thead class="text-lavuro">
            <tr>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top">
                Titulo<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.title"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Categoría<br>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Fecha / Coord.<br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.createdAtStart"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" /><br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.createdAtEnd"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" *ngIf="!clientId">
                Cliente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Estado<br>
                <select class="filter small" [(ngModel)]="filter.filters.status" (ngModelChange)="lazySearch()"
                  (click)="$event.stopPropagation()" style="max-width: 1000px;">
                  <option [ngValue]="undefined"> - select - </option>
                  <option *ngFor="let key of taskStatusesKeys" [ngValue]="key">{{taskStatuses[key]}}</option>
                </select>
              </th>

              <th class="d-none d-md-table-cell align-top">
                Facturable?<br>
              </th>

              <!-- Mobile -->
              <th class="d-table-cell d-md-none">
                Orden por: <span class="ml-2">{{ sortOptions[filter.sort || 'defaultKey'] || 'ninguno' }}</span>
                <span class="text-lavuro pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
              </th>

              <!-- All -->
              <th class="td-actions text-right p-0" width="1%">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                    <span>Orden</span>
                  </button>

                  <!-- filters -->
                  <button mat-menu-item (click)="openFilter()">
                    <span>Filtro avanzado</span>
                  </button>
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>

                  <!-- actions -->
                  <!-- 
                      <ng-container>
                        <button mat-menu-item (click)="openBulkDeleteActionTaskConfirm()">
                          <span>Eliminar</span>
                        </button>
                        <button mat-menu-item (click)="openBulkRestoreActionTaskConfirm()">
                          <span>Restaurar</span>
                        </button>
                      </ng-container>
                      -->
                </mat-menu>

                <mat-menu #order="matMenu">
                  <ng-container *ngFor="let key of sortOptionsKeys">
                    <button mat-menu-item (click)="sortTasks(key)">
                      <span>{{sortOptions[key]}}</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="sortTasks('')">
                    <span>Sin Ordenar</span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>

          <tbody class="overflow-auto">
            <tr *ngFor="let task of tasks" [class.text-danger]="task.isDeleted"
              [class.background-agreement]="task.serviceAgreement" class='cursor-pointer' (click)="closeDialog(task)">

              <!-- PC -->
              <td class="d-none d-md-table-cell">
                {{task.title}}
              </td>
              <td class="d-none d-md-table-cell">{{task.category?.[0]?.name}}</td>
              <td class="d-none d-md-table-cell text-left">
                <span *ngIf="task.scheduledStart">
                  {{task.scheduledStart | date:'dd/MM/yyyy HH:mm'}}
                  <i class="material-icons inline-icon">pending_actions</i>
                </span>
                <span *ngIf="!(task.scheduledStart)">{{task.createdAt | date:'dd/MM/yyyy'}}</span>
              </td>
              <td class="d-none d-md-table-cell" *ngIf="!clientId">{{task.client?.firstname}} {{task.client?.lastname}}
              </td>
              <td class="d-none d-md-table-cell">{{taskStatuses[task.status || '']}}</td>
              <td class="d-none d-md-table-cell">
                <span *ngIf="!!task.serviceAgreement">No</span>
                <span *ngIf="!!!task.serviceAgreement">Si</span>
              </td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <span class="font-weight-bold">{{task.title}}</span><br>
                <span class="small pull-left">
                  por: {{task.client?.firstname}} {{task.client?.lastname}},
                  <span *ngIf="task.scheduledStart">
                    {{task.scheduledStart | date:'dd/MM/yyyy HH:mm'}}
                    <i class="material-icons inline-icon">pending_actions</i>
                  </span>
                  <span *ngIf="!(task.scheduledStart)">{{task.createdAt | date:'dd/MM/yyyy'}}</span>
                </span>
                <span class="small pull-left">
                  Estado: {{taskStatuses[task.status || '']}}.
                </span>
                <span class="small pull-left" *ngIf="task.coordinated">
                  Coordinada: {{task.task_date | date:'dd/MM/yyyy HH:mm'}}
                  <i class="material-icons inline-icon">pending_actions</i>
                </span>
                <span class="small pull-left" *ngIf="!!task.serviceAgreement">No Facturable</span>
                <span class="small pull-left" *ngIf="!!!task.serviceAgreement">Facturable</span>
                <span class="small pull-right" *ngIf="task.isDeleted">borrada</span>
              </td>

              <!-- All -->
            </tr>

            <!-- All -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-lavuro text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>

          <tfoot class="text-lavuro">
            <tr>
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ tasks.length }} trabajos</td>
            </tr>
          </tfoot>
        </table>
      </div>

    </div>
  </div>
</div>